import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import {
    buildPageContextFields, buildPromptFields, buildLyraAdviceFields, buildSentimentChipFields
} from 'ai/analytics/utils/sotFields';
import { EVENT_NAMES } from 'ai/analytics/events';

export function trackPromptClick({ promptText, pageContext = {} }) {
    if (!promptText) {
        return;
    }

    const eventName = EVENT_NAMES.PROMPT_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildPromptFields(promptText),
        ...buildLyraAdviceFields()
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        },
        finishEventWithoutTimeout: true
    });
}

export function trackFollowUpClick({ followUpText, pageContext = {}, messageId, previousMessageId }) {
    if (!followUpText) {
        return;
    }

    const eventName = EVENT_NAMES.FOLLOW_UP_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildPromptFields(followUpText, messageId, previousMessageId),
        ...buildLyraAdviceFields()
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}

export function trackSentimentChipClick({ value, position, type, pageContext = {} }) {
    if (!value || !position) {
        return;
    }

    const eventName = EVENT_NAMES.SENTIMENT_CHIP_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildSentimentChipFields({ value, position, type }),
        ...buildLyraAdviceFields()
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}

export function trackSignInCTAClick({ pageContext = {} }) {
    const eventName = EVENT_NAMES.SIGN_IN_CTA_CLICK;
    const sotFields = {
        ...buildPageContextFields(pageContext),
        ...buildLyraAdviceFields()
    };

    processEvent.process(anaConsts.SOT_LINK_TRACKING_EVENT, {
        data: {
            linkName: eventName,
            actionInfo: eventName,
            specificEventName: eventName,
            sotType: eventName,
            ...sotFields
        }
    });
}
